export default __webpack_public_path__ + "static/media/studentIndividualStudying.1996ef6b.png";